import {buildActionObject} from "../../../utils/actions_utils";
import {AUTH_SET_NEXT} from "../../../values/action_types";

export const setNextLink = next => buildActionObject(AUTH_SET_NEXT, {next});